import { render, staticRenderFns } from "./EditOrderPart.vue?vue&type=template&id=c6026e4a&scoped=true&"
import script from "./EditOrderPart.vue?vue&type=script&lang=js&"
export * from "./EditOrderPart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6026e4a",
  null
  
)

export default component.exports